export default __webpack_public_path__ + "static/media/solfeggioen.466ac0a1.jpeg";